export const GET_PRODUCTION_TYPES = "GET_PRODUCTION_TYPES";
export const GET_PRODUCTION_TYPE_BY_ID = "GET_PRODUCTION_TYPE_BY_ID";
export const UPDATE_PRODUCTION_TYPE = "UPDATE_PRODUCTION_TYPE";
export const DELETE_PRODUCTION_TYPE = "DELETE_PRODUCTION_TYPE";
export const CREATE_PRODUCTION_TYPE = "CREATE_PRODUCTION_TYPE";
